import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    greet: 'Greeting From Redux',
    isLoading: false
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setGreetMsg: (state, action) => {
            state.greet = action.payload
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
    },
})

export const { setGreetMsg, setIsLoading } = appSlice.actions
export default appSlice.reducer